import { apiClient } from './client';
import type { ApiResponse } from '@/types/api.types';

export type EmailProvider = 'Smtp' | 'Resend';

export interface EmailSettingDto {
  provider:  EmailProvider;
  /** The key itself is never returned — this only says whether one is stored. */
  hasApiKey: boolean;
  fromEmail: string;
  fromName:  string;
  replyTo:   string | null;
  isActive:  boolean;
}

export interface UpdateEmailSettingRequest {
  provider:      EmailProvider;
  /** Leave blank to keep the stored key unchanged. */
  resendApiKey?: string | null;
  fromEmail:     string;
  fromName:      string;
  replyTo?:      string | null;
  isActive:      boolean;
}

export const emailSettingsApi = {
  /** GET /api/v1/email-settings */
  get: () => apiClient.get<ApiResponse<EmailSettingDto>>('/email-settings'),

  /** PUT /api/v1/email-settings */
  update: (data: UpdateEmailSettingRequest) =>
    apiClient.put<ApiResponse<EmailSettingDto>>('/email-settings', data),

  /** POST /api/v1/email-settings/test — sends a test message with the saved settings. */
  sendTest: (toEmail: string) =>
    apiClient.post<ApiResponse<{ sent: boolean }>>('/email-settings/test', { toEmail }),
};
